

    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { ControladorInterfaz } from '../../controlador';
    import pregunta from './resumen-preguntas-ml-pregunta.vue';

    import { Item } from '@/__env/lib/Ventas/Pedidos/Item';
    import { Factura } from '@/__env/lib/CuentasCorrientes/Facturas';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import { Pregunta } from '@/__env/lib/MercadoLibre/Preguntas';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            pregunta
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Pregunta: Pregunta;
        @Watch( 'Pregunta' )
        onPregunta()
        {
            this.Respuesta = '';
        }

        public Cargando: boolean = false;
        public Focused: boolean = false;
        public Respuesta: string = '';

        async Enviar()
        {
            if ( !this.Respuesta )
                return;

            this.Cargando = true;
            await Wait( 100 );
            let e = await this.Pregunta.Responder( this.Respuesta );
            if ( e )
            {
                if ( e == "ya-respondida" )
                {
                    Utiles.Notificaciones.Error( 'Pregunta respondida por otro usuario' );
                }
                this.$emit( 'aplicado', true );
                this.Cargando = false;
                this.Cerrar();
            } else
            {
                await Wait( 100 );
                this.Cargando = false;
                Utiles.Notificaciones.Error( 'Error al responder' );
            }
        }

        Cerrar()
        {
            this.$emit( 'cerrar' );
        }

    }
